import { Sparkle } from "lucide-react";

const WORDS = [
  "AWAKENING",
  "CONSCIOUSNESS",
  "ENERGY",
  "FREQUENCY",
  "INNER WORK",
  "ANCIENT WISDOM",
  "TRANSFORMATION",
  "COMMUNITY",
];

export default function Marquee() {
  const row = (key) => (
    <div key={key} className="flex shrink-0 items-center">
      {WORDS.map((w) => (
        <span key={`${key}-${w}`} className="flex items-center">
          <span className="font-display px-8 text-xs tracking-[0.45em] text-slate-400 sm:text-sm">
            {w}
          </span>
          <Sparkle className="h-3 w-3 text-cyan-300/70" strokeWidth={1.5} />
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid="frequency-marquee"
      className="relative overflow-hidden border-y border-white/10 bg-black/50 py-6 backdrop-blur-md"
    >
      <div className="marquee-track">
        {row("a")}
        {row("b")}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#040308] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#040308] to-transparent" />
    </div>
  );
}
